import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-delegation-badge',
  templateUrl: './delegation-badge.component.html',
  styleUrls: ['./delegation-badge.component.scss'],
  standalone: true,
  imports: [NgIf, TranslateModule],
})
export class DelegationBadgeComponent {
  protected _showOnBehalfOf = false;
  @Input() set showOnBehalfOf(value: BooleanInput) {
    this._showOnBehalfOf = coerceBooleanProperty(value);
  }

  @Input() delegatee?: string;
  @Input() avatar?: string;
}
